module.exports = __webpack_public_path__ + "img/hp.a16bdcf0.svg";